import { render } from "./multiText.vue?vue&type=template&id=1de32170&ts=true"
import script from "./multiText.vue?vue&type=script&lang=ts"
export * from "./multiText.vue?vue&type=script&lang=ts"

import "./multiText.vue?vue&type=style&index=0&id=1de32170&lang=less"

import exportComponent from "D:\\test\\newDemo\\alp-ui\\vue-component\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__